import { IRaisePropertyChanged } from "./IRaisePropertyChanged";

export class NotifyProperty<T> {
    private readonly propertyName: string;

    public get name(): string {
        return this.propertyName;
    }

    private readonly ownerValue: IRaisePropertyChanged;
    private valueOfProperty: T;

    public constructor(owner: IRaisePropertyChanged, name: string, initialValue: T) {
        this.ownerValue = owner;
        this.propertyName = name;
        this.valueOfProperty = initialValue;
    }

    public get value(): T {
        return this.valueOfProperty;
    }

    public setValue(newValue: T): void {
        if (newValue !== this.value) {
            this.valueOfProperty = newValue;
            this.ownerValue.raisePropertyChanged(this.name);
        }
    }
}
